var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "leftmenu/games/icon-table") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "1.33055874e-13%",
    x2: "50%",
    y2: "104.53891%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb61a",
    stopOpacity: 0.7,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb61a",
    stopOpacity: 0.995478029,
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb61a",
    stopOpacity: 0.995478029,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.0976154,5 L20.5069615,5.04961989 C25.9188077,5.717331 30,10.2003801 30,15.4784261 C30,21.2796384 25.1201923,26 19.1205385,26 L11.8805769,26 C5.88092308,26 1,21.2796384 1,15.4784261 C1,10.2003801 5.08119231,5.717331 10.4941538,5.04961989 L10.9035,5 L11.3596923,6.08192932 C11.3898077,6.13478529 11.6061923,6.26638586 11.9586538,6.26638586 L19.0424615,6.26638586 C19.3938077,6.26638586 19.6113077,6.13478529 19.6425385,6.07977193 L20.0976154,5 Z M19.1205385,7.97611465 L11.8805769,7.97611465 C7.60753846,7.97611465 4.12976923,11.3351654 4.12419231,15.4665605 C4.12976923,19.5979556 7.60753846,22.9570064 11.8805769,22.9570064 L19.1205385,22.9570064 C23.3935769,22.9570064 26.8702308,19.5979556 26.8769231,15.4665605 C26.8702308,11.3351654 23.3935769,7.97611465 19.1205385,7.97611465 Z M19.1202038,9.4531693 C22.5422038,9.4531693 25.3262038,12.1455876 25.3262038,15.4550185 C25.3262038,18.7644494 22.5422038,21.4568677 19.1202038,21.4568677 L11.8802423,21.4568677 C8.45824231,21.4568677 5.67424231,18.7644494 5.67424231,15.4550185 C5.67424231,12.1455876 8.45824231,9.4531693 11.8802423,9.4531693 Z M19.1202038,11.4541453 L11.8802423,11.4541453 C9.59928077,11.4541453 7.74328077,13.2490908 7.74328077,15.4550185 C7.74328077,17.6609462 9.59928077,19.4558917 11.8802423,19.4558917 L19.1202038,19.4558917 C21.4011654,19.4558917 23.2571654,17.6609462 23.2571654,15.4550185 C23.2571654,13.2490908 21.4011654,11.4541453 19.1202038,11.4541453 Z M15.5002231,13.7641668 C16.0713,13.7641668 16.5341846,14.2118245 16.5341846,14.7641155 L16.5341846,15.7651428 C16.5341846,16.3174337 16.0713,16.7650914 15.5002231,16.7650914 C14.9291462,16.7650914 14.4662615,16.3174337 14.4662615,15.7651428 L14.4662615,14.7641155 C14.4662615,14.2118245 14.9291462,13.7641668 15.5002231,13.7641668 Z M11.8802423,13.7641668 C12.4513192,13.7641668 12.9142038,14.2118245 12.9142038,14.7641155 L12.9142038,15.7651428 C12.9142038,16.3174337 12.4513192,16.7650914 11.8802423,16.7650914 C11.3091654,16.7650914 10.8462808,16.3174337 10.8462808,15.7651428 L10.8462808,14.7641155 C10.8462808,14.2118245 11.3091654,13.7641668 11.8802423,13.7641668 Z M19.1202038,13.7641668 C19.6912808,13.7641668 20.1541654,14.2118245 20.1541654,14.7641155 L20.1541654,15.7651428 C20.1541654,16.3174337 19.6912808,16.7650914 19.1202038,16.7650914 C18.5491269,16.7650914 18.0862423,16.3174337 18.0862423,15.7651428 L18.0862423,14.7641155 C18.0862423,14.2118245 18.5491269,13.7641668 19.1202038,13.7641668 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-13.8%",
    y: "-9.5%",
    width: "127.6%",
    height: "138.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "leftmenu/games/icon-table",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTable);
export default __webpack_public_path__ + "static/media/icon-table.987342a4b102c1322590bb3d9cc88688.svg";
export { ForwardRef as ReactComponent };